import { dropStatusDocumento, dropAprovacao } from 'utils/drops';

const getPedidosFilterFields = (drops = {}) => [
  { name: 'id', label: 'ID', type: 'number', defaultValue: '' },
  {
    name: 'status',
    label: 'Status',
    type: 'select',
    options: dropStatusDocumento,
    multiple: true,
    defaultValue: ['PENDENTE'],
  },
  {
    name: 'situacao',
    label: 'Situação',
    type: 'select',
    options: drops?.StatusDocumento,
    multiple: true,
    defaultValue: [],
  },
  {
    name: 'dtemissao.i',
    column: 'dtemissao',
    label: 'Data de Emissão Inicial',
    type: 'date',
    defaultValue: null,
  },
  {
    name: 'dtemissao.f',
    column: 'dtemissao',
    label: 'Data de Emissão Final',
    type: 'date',
    defaultValue: null,
  },
  {
    name: 'documento',
    label: 'Nº do Documento',
    type: 'number',
    defaultValue: '',
    initial: true,
  },
  {
    name: 'entidade',
    label: 'Entidade',
    type: 'virtual-select',
    options: drops?.Entidade,
    multiple: true,
    defaultValue: [],
  },
  { name: 'vldocto', label: 'Valor', type: 'currency', defaultValue: '' },
  {
    name: 'filial',
    label: 'Filial',
    type: 'select',
    options: drops?.Filial,
    multiple: true,
    defaultValue: [],
  },
  {
    name: 'przent.i',
    column: 'przent',
    label: 'Prazo de Entrega Inicial',
    type: 'date',
    defaultValue: null,
  },
  {
    name: 'przent.f',
    column: 'przent',
    label: 'Prazo de Entrega Final',
    type: 'date',
    defaultValue: null,
  },
  {
    name: 'documento_nota',
    label: 'Nº da Nota',
    type: 'number',
    defaultValue: '',
  },
  { name: 'whatsapp', label: 'Contato', defaultValue: '' },
  {
    name: 'aprovacao',
    label: 'Aprovado',
    type: 'select',
    options: dropAprovacao,
    defaultValue: null,
  },
  {
    name: 'planoconta',
    label: 'Plano de Conta',
    type: 'select',
    options: drops?.Planoconta,
    defaultValue: null,
  },
  {
    name: 'ccusto',
    label: 'Centro de Custo',
    type: 'select',
    options: drops?.Ccusto,
    defaultValue: null,
  },
];

export default getPedidosFilterFields;
